import { fromUint8Array } from 'js-base64';
import { gzip } from 'pako';
import { FieldMapping } from '../interfaces';
import { Tool } from './base';
export class MicrosoftSentinelTool extends Tool {
  public readonly toolName = 'Microsoft Sentinel';

  // Temporary until a better global default for Sentinel can be built
  public defaultFieldMapping: FieldMapping = {
    name: 'foo',
    category: 'foo',
    fields: [],
    toolSpecific: [{ tableName: '*' }],
  };

  public readonly toolDefaultCCMFieldMappings = {
    //src_ip: '',
    //application_name: '',
    //parent_process_cmdline: '',
    access: 'AccessMask',
    action: 'Activity',
    application_name: 'Application',
    dest_domain: 'DestAddress',
    logon_process: 'LogonProcessName',
    object_loaded: 'ObjectName',
    protocol: 'Protocol',
    record_id: 'Task',
    sid: 'SubjectUserSid',
    src_hostname: 'Computer',
    src_ip: 'IpAddress',
    src_port: 'IpPort',
    task_category: 'TaskCategory',
    accesses: 'AccessList',
    dest_ip: 'RemoteIpAddress',
    dest_port: 'RemotePort',
    event_id: 'EventID',
    event_type: 'EventTypeName',
    file_name: 'ObjectName',
    file_path: 'ObjectName',
    hostname: 'Computer',
    logon_type: 'LogonType',
    message: 'EventData',
    object_name: 'ObjectName',
    parent_process_id: 'ProcessId',
    parent_process_name: 'ParentProcessName',
    parent_process_path: 'ParentProcessName',
    process_cmdline: 'CommandLine',
    process_id: 'NewProcessId',
    process_name: 'Process',
    process_path: 'NewProcessName',
    registry_key_name: 'ObjectValueName',
    registry_new_value_name: 'NewValue',
    registry_old_value_name: 'OldValue',
    registry_path: 'ObjectName',
    registry_value_name: 'NewValue',
    service_file_path: 'ServiceFileName',
    service_name: 'ServiceName',
    target_path: 'ObjectName',
    username: 'SubjectUserName',
    user_agent: 'UserAgent',
    region: 'AWSRegion',
    event_name: 'EventName',
    user_type: 'UserIdentityType',
    group_id: 'UserIdentityAccountId',
    identity_principal_id: 'UserIdentityPrincipalid',
    bytes_in: 'parse_json(AdditionalEventData).bytesTransferredOIn',
    bytes_out: 'parse_json(AdditionalEventData).bytesTransferredOIn',
    account_id: 'UserIdentityAccountId',
    error_code: 'ErrorCode',
    error_message: 'ErrorMessage',
    dest_hostname: 'parse_json(RequestParameters).Host',
    storage_property_name: 'parse_json(RequestParameters).bucketName',
    storage_target_object: 'parse_json(RequestParameters).key',
    user_access_id: 'UserIdentityAccessKeyId',
    source_user_role: 'parse_json(RequestParameters).roleArn',
    user_role: 'UserIdentityArn',
    mfa_auth: 'SessionMfaAuthenticated',
    cloud_event_id: 'AwsEventId',
    request_parameters: 'RequestParameters',
  };

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string,
  ): string {
    const encodedRenderedContent = encodeURIComponent(
      fromUint8Array(gzip(renderedContent)),
    );
    return `${rootURL}source/LogsBlade.AnalyticsShareLinkToQuery/q/${encodedRenderedContent}/timespan/P1D`;
  }
}
